module.exports = __webpack_public_path__ + "img/logo-towers-highlight@2x.2bb2c677.png";